import I18n from 'I18n';
import { ListsIcon } from 'foundations-assets/icons/components/ListsIcon';
import { getSortedFlattenedTeamsList } from '../../utils/TeamUtils';
import { FilterOptionTypes } from './Constants';
import { jsx as _jsx } from "react/jsx-runtime";
const makeTeamSelectOption = ({
  depth,
  id,
  name
}) => {
  return {
    depth,
    value: id,
    text: name,
    avatar: /*#__PURE__*/_jsx(ListsIcon, {
      size: "100"
    }),
    type: FilterOptionTypes.TEAM
  };
};
const getTeamOptions = ({
  teams
}) => {
  const teamOptions = getSortedFlattenedTeamsList(teams).map(team => makeTeamSelectOption({
    depth: team.depth || 0,
    id: team.id,
    name: team.name
  }));
  return [{
    text: I18n.text('ui-asset-management-lib.labels.teams'),
    options: teamOptions
  }];
};
export default getTeamOptions;